// extracted by mini-css-extract-plugin
export default {"container":"ChooseAddressModal_container__OsDkh","addressButtonRow":"ChooseAddressModal_addressButtonRow__vIHPe","actionButtonRow":"ChooseAddressModal_actionButtonRow__b-5qy"};